<ion-grid class="ion-no-padding">
  <ion-row>
    <ion-col
      *ngFor="let head of node?.content[0]; index as h"
      [innerHTML]="head"
    ></ion-col>
  </ion-row>
  <ion-row *ngFor="let col of node?.content | slice: 1; index as i">
    <ion-col size="6" size-lg *ngFor="let cell of col; index as k">
      <div class="table-col-data" [innerHTML]="cell"></div>
    </ion-col>
  </ion-row>
</ion-grid>
